'use client'

import {Display} from '@/components/ui/Typography'
import Image from 'next/image'
import {useEffect, useState} from 'react'

interface ImageGalleryProps {
  images: string[]
  boxName: string
}

export const ImageGallery = ({images, boxName}: ImageGalleryProps) => {
  const [selectedImage, setSelectedImage] = useState(0)

  const [isPortrait, setIsPortrait] = useState(false)

  useEffect(() => {
    const img = new window.Image()
    img.src = images[selectedImage]
    img.onload = () => {
      setIsPortrait(img.naturalHeight > img.naturalWidth)
    }
  }, [selectedImage, images])

  if (images.length === 0) return null

  return (
    <div>
      <Display className="text-xl font-bold mb-2 mt-6">Bilder</Display>

      {/* Main Image */}
      <div className="aspect-[16/9] relative rounded-lg overflow-hidden bg-[#E7EDEE]">
        <Image
          src={images[selectedImage]}
          alt={`Box ${boxName} - Main Image`}
          fill
          className={isPortrait ? 'object-contain' : 'object-cover'}
          sizes="(max-width: 1200px) 100vw, 1200px"
          priority
        />
      </div>

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto py-2">
          {images.map((image, index) => (
            <button
              key={image}
              onClick={() => setSelectedImage(index)}
              className={`relative flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden 
    ${selectedImage === index ? 'border-2 border-kettlebell-500' : 'border border-transparent'}
  `}
            >
              <Image src={image} alt={`Box ${boxName} - Thumbnail ${index + 1}`} fill className="object-cover" sizes="80px" />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
